<script>
  import {
    windowsComputed,
  } from '@state/helpers'

  export default {
    props: {
      filtersHidden:{
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...windowsComputed,
    },
  }
</script>

<template>
  <div class="filters-panel in-modal">
    <slot name="search" />
    <FabricTransitionHeight>
      <article v-show="!isTablet  || (isTablet && !filtersHidden)">
        <slot name="extra-filters" />
      </article>
    </FabricTransitionHeight>
  </div>
</template>
